"use client";
import { Button } from "@fanduel/formation-react-components";
import {
  ArrowsChevronRight,
  BettingTrophy,
} from "@fanduel/formation-react-icons";
import { PROMOTIONS_FALLBACK_URL } from "@/constants/promotions";
import { Promotion } from "@/graphql/gql/graphql";
import PromotionDisplay from "./Promotion";
import styles from "./promotionsWidget.module.scss";

type PromotionsWidgetProps = {
  promotions?: Promotion[];
  articleName?: string;
  competition?: string;
  sport?: string;
};

const PromotionsWidget = ({ promotions, ...props }: PromotionsWidgetProps) => {
  if (!promotions?.length) return null;

  return (
    <div className={styles.container}>
      <div className={styles.heading}>
        <div className={styles.iconAndText}>
          <BettingTrophy width={20} height={20} />
          <h2>Featured Promos</h2>
        </div>
        <a href={PROMOTIONS_FALLBACK_URL} target="_blank" rel="noreferrer">
          <Button
            variant="link"
            iconRight={<ArrowsChevronRight />}
            label="View All"
          />
        </a>
      </div>
      {promotions.map((promo) => (
        <PromotionDisplay key={promo.promoCode} {...props} promo={promo} />
      ))}
    </div>
  );
};

export default PromotionsWidget;
